import React, { useRef, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import Loader from '@/Components/Common/Loader'
import ShiftTypeService from '@/Service/ShiftTypeService'
import TimePicker from '@/Components/Common/TimePicker'

const UpdateShiftType = () => {
    const formRef = useRef(null)
    const [isSaving, setIsSaving] = useState(false)
    const formSchema = z.object({
        shift_name: z.string().min(1, {
            message: 'Shift name is required',
        }),
         start_time: z.string().min(1, {
            message: 'Start time is required',
        }),
         end_time: z.string().min(1, {
            message: 'End time is required',
        }),

        
    })

    const { shiftData } = useLoaderData()
    console.log('shiftData', shiftData)

    const navigate = useNavigate()
    const form = useForm({
        shouldFocusError: false,
        resolver: zodResolver(formSchema),
        defaultValues: {
            shift_name: shiftData.shift_name,
            start_time: shiftData.start_time,
            end_time: shiftData.end_time,
        },
    })

    async function onSubmit(values) {
        console.log('values', values)
        values['name']=shiftData.name

        try {
            setIsSaving(true)

            const resp = await ShiftTypeService.updateShiftTpe(values)
            console.log('data', resp)
            if (resp.data.success) {
                setIsSaving(false)
                navigate('.', { replace: true })
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const values = form.getValues() 
        console.log('Validation errors:', errors)
        console.log('Form values at time of error:', values)
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        } else {
            toast.error('Something went wrong.')
        }
    }

    const handleSaveClick = () => {
        if (formRef.current) {
            formRef.current.requestSubmit()
        }
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            className="bg-primary-purpal hover:bg-primary-purpal px-4"
                            onClick={handleSaveClick}
                            iconType="Save"
                            disabled={isSaving}
                        >
                            Save {isSaving && <Loader fullScreen={false} />}
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>
                <Form {...form}>
                    <form ref={formRef} onSubmit={form.handleSubmit(onSubmit, onError)} className="">
                        <div className="grid grid-cols-2 gap-y-4 gap-x-6">
                            <FormField
                                control={form.control}
                                name="shift_name"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Shift Name</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Shift Name"
                                                disabled={true}
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-y-4 gap-x-6">
                            <FormField
                                control={form.control}
                                name="start_time"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Start Time</FormLabel>
                                        <FormControl>
                                            <TimePicker
                                                {...field}
                                                handleChanges={(val) => {
                                                   field.onChange(val)
                                                }}
                                                type="time"
                                                className="flex h-min w-full rounded-md border border-neutral-200 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-neutral-500 focus-visible:outline-none   disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutral-800 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 "
                                                placeholder="Start Time"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="end_time"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>End Time</FormLabel>
                                        <FormControl>
                                            <TimePicker
                                                {...field}
                                                handleChanges={(val) => {
                                                    field.onChange(val)
                                                }}
                                                type="time"
                                                className="flex h-min w-full rounded-md border border-neutral-200 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-neutral-500 focus-visible:outline-none   disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutral-800 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 "
                                                placeholder="End Time"
                                                
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </div>
                    </form>
                </Form>
            </BodyCard>
        </>
    )
}

export default UpdateShiftType
